<script setup lang="ts">
import professorImage from '../../../src/renderer/assets/abs.PNG'

withDefaults(defineProps<{
  variant?: 'brand' | 'dock' | 'welcome' | 'avatar' | 'loader'
}>(), {
  variant: 'avatar',
})
</script>

<template>
  <span class="professor-mark" :class="`professor-mark--${variant}`" aria-hidden="true">
    <img :src="professorImage" alt="" />
  </span>
</template>
